// extracted by mini-css-extract-plugin
export default {"feedbackCard":"page_feedbackCard__wMqQ0","feedbackTime":"page_feedbackTime__vRt3R","collapsedMessage":"page_collapsedMessage__b0J6j","expandedMessage":"page_expandedMessage__qlaQ7"};